export default __webpack_public_path__ + "static/media/No-Image-Placeholder.f597af39.svg";